import React from 'react';
import { VERTRIEB_STATUS } from '../statusColors';

// Erneuter Klick auf den aktiven Status erhöht den Besuchszähler — bei Geclosed und
// Kein Interesse ergibt ein erneuter Klick keinen Sinn (Endzustand), daher gesperrt
const NO_RECOUNT = ['Geclosed', 'Kein Interesse', 'Nicht schreibbar'];

export default function StatusPicker({ current, count = 1, onSelect, onCountIncrement }) {
  return (
    <div className="status-picker">
      {VERTRIEB_STATUS.map(s => {
        const isActive = current === s.value;
        const locked = isActive && NO_RECOUNT.includes(s.value);
        return (
          <button
            key={s.value ?? 'null'}
            className={`status-btn${isActive ? ' active' : ''}`}
            style={{ '--color': s.color }}
            disabled={locked}
            onClick={() => {
              if (locked) return;
              if (isActive && s.value !== null) {
                onCountIncrement?.();
              } else {
                onSelect(s.value);
              }
            }}
          >
            <span className="status-dot" style={{ background: s.color }} />
            {s.label}
            {isActive && count > 1 && (
              <span className="status-count">×{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
